import { ResolverSupportingSlug } from '@core/frontend-shared/utils';
import { Store } from '@ngxs/store';
import { switchMap } from 'rxjs/operators';
import { CourseStateFacade } from './course-state.facade';
import { CourseState } from './course.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "./course-state.facade";
export let SceneResolver = /*#__PURE__*/(() => {
  class SceneResolver extends ResolverSupportingSlug {
    constructor(store, facade) {
      super();
      this.store = store;
      this.facade = facade;
    }
    resolve(route) {
      const id = this.extractId(route, 'id');
      const sceneId = this.extractId(route, 'sceneId');
      // wait for async selectCourse to complete, then return selectedCourse from store using selectOnce
      return this.facade.selectCourse(id).pipe(switchMap(() => {
        return this.facade.selectScene(sceneId);
      }), switchMap(() => {
        return this.store.selectOnce(CourseState.selectedScene);
      }));
    }
    static {
      this.ɵfac = function SceneResolver_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SceneResolver)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.CourseStateFacade));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: SceneResolver,
        factory: SceneResolver.ɵfac
      });
    }
  }
  return SceneResolver;
})();